import axios from 'axios';
import { stringify } from 'querystring';
import { csrfTokenName, csrfTokenValue } from '../craft';

export class HttpModule {
    headers = {};

    constructor(customHeaders = {}) {
        this.headers = {
            ...this.headers,
            ...customHeaders,
        };
    }

    post(url, data, customHeaders = {}) {
        const dataWithCsrf = {
            [csrfTokenName]: csrfTokenValue,
            ...data,
        };

        const headers = {
            ...this.headers,
            ...customHeaders,
        };

        return axios.post(url, stringify(dataWithCsrf), headers);
    }

    get(url, customHeaders = {}) {
        const headers = {
            ...this.headers,
            ...customHeaders,
        };

        return axios.get(url, headers);
    }
}


export const http = new HttpModule();



// WEBPACK FOOTER //
// ./assets/js/core/http.js